<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br>
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/home'"></i>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <h5>足あと</h5>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <br />
            <div class="container" style="margin-top:30px;">
                <br>
                <div v-if="login_user.can_use_all_features">
                    <div class="row">
                        <div class="col text-center luna-color">
                            あなたを訪問してくれた人の数：{{ count | priceLocaleString }}人
                        </div>
                    </div>
                    <br>
                    <div class="" v-for="user in user_list" :key="user" style="padding: 0;">
                        <div class="row" v-if="user.type == 1">
                            <div class="col px-0 text-center">
                                <p class="dateline"> {{ user.item }}</p>
                            </div>
                        </div>
                        <div class="row justify-content-center" v-else-if="user.type == 2">
                            <div class="col-10">
                                <div class="row" style="padding: 0px">
                                    <div class="col-3" :onclick="`window.location.href = '/user/show/${user.item.id}?profile_source=footprint_list'`">
                                        <img :src="user.item.icon_url" class="rounded-circle" style="width: 100%" />
                                    </div>
                                    <div class="col" :onclick="`window.location.href = '/user/show/${user.item.id}?profile_source=footprint_list'`">
                                        <div style="padding-top:0px;">
                                            {{ user.item.name }}
                                        </div>
                                        <div style="padding: 5px; font-size: 12px; font-weight: bold"
                                            v-if="user.item.age_view">
                                            {{ area_list[user.item.area] }}
                                            {{ age_list[user.item.age] }}
                                            {{ sex_list[user.item.sex] }}
                                        </div>
                                        <div style="padding: 5px; font-size: 12px; font-weight: bold" v-else>
                                            {{ area_list[user.item.area] }}
                                            秘密
                                            {{ sex_list[user.item.sex] }}
                                        </div>
                                    </div>
                                    <div class="col-2 text-end" style="color: #979c9e;white-space: nowrap;">
                                        {{ user.item.footprint_time }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                    <div class="text-center" style="padding-top: 50px; padding-bottom: 20px; color: #6c7072"
                        v-if="is_page && count != 0">
                        <a @click="fetchUsersMore">もっとみる</a>
                        <br />
                        <br />
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col px-0">
                            <div class="planbox text-center">
                                <br>
                                <div style="padding: 0 20px;">
                                    <p>足あとを表示するには、有料化プランになります。</p>

                                    <RecommendPlanBanner
                                        src="/images/recommend_banners/recommend_plan_update_banner_footprint.png"
                                        alt="プランアップグレードのご案内。足跡からあなたに興味がある人へのアプローチでマッチング率5倍！" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col text-center luna-color">
                            あなたを訪問してくれた人の数： -- 人
                        </div>
                    </div>
                    <br>
                    <div class="mosaic">
                        <div class="row">
                            <div class="col px-0 text-center">
                                <p class="dateline"> -- 月 -- 日</p>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-10">
                                <div class="row" style="padding: 0px">
                                    <div class="col-3">
                                        <img src="/images/icon_user.png" class="rounded-circle" style="width: 100%" />
                                    </div>
                                    <div class="col">
                                        <h3 style="padding-top:8px;">
                                            xxxxxx
                                        </h3>
                                        <div style="padding: 5px; font-size: 12px; font-weight: bold">
                                            性別
                                            年齢
                                            住所
                                        </div>
                                    </div>
                                    <div class="col-2 text-end" style="color: #979c9e">
                                        00:00
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="row justify-content-center">
                            <div class="col-10">
                                <div class="row" style="padding: 0px">
                                    <div class="col-3">
                                        <img src="/images/icon_user.png" class="rounded-circle" style="width: 100%" />
                                    </div>
                                    <div class="col">
                                        <h3 style="padding-top:8px;">
                                            xxxxxx
                                        </h3>
                                        <div style="padding: 5px; font-size: 12px; font-weight: bold">
                                            性別
                                            年齢
                                            住所
                                        </div>
                                    </div>
                                    <div class="col-2 text-end" style="color: #979c9e">
                                        00:00
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="row justify-content-center">
                            <div class="col-10">
                                <div class="row" style="padding: 0px">
                                    <div class="col-3">
                                        <img src="/images/icon_user.png" class="rounded-circle" style="width: 100%" />
                                    </div>
                                    <div class="col">
                                        <h3 style="padding-top:8px;">
                                            xxxxxx
                                        </h3>
                                        <div style="padding: 5px; font-size: 12px; font-weight: bold">
                                            性別
                                            年齢
                                            住所
                                        </div>
                                    </div>
                                    <div class="col-2 text-end" style="color: #979c9e">
                                        00:00
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="row justify-content-center">
                            <div class="col-10">
                                <div class="row" style="padding: 0px">
                                    <div class="col-3">
                                        <img src="/images/icon_user.png" class="rounded-circle" style="width: 100%" />
                                    </div>
                                    <div class="col">
                                        <h3 style="padding-top:8px;">
                                            xxxxxx
                                        </h3>
                                        <div style="padding: 5px; font-size: 12px; font-weight: bold">
                                            性別
                                            年齢
                                            住所
                                        </div>
                                    </div>
                                    <div class="col-2 text-end" style="color: #979c9e">
                                        00:00
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="row">
                            <div class="col px-0 text-center">
                                <p class="dateline"> -- 月 -- 日</p>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-10">
                                <div class="row" style="padding: 0px">
                                    <div class="col-3">
                                        <img src="/images/icon_user.png" class="rounded-circle" style="width: 100%" />
                                    </div>
                                    <div class="col">
                                        <h3 style="padding-top:8px;">
                                            xxxxxx
                                        </h3>
                                        <div style="padding: 5px; font-size: 12px; font-weight: bold">
                                            性別
                                            年齢
                                            住所
                                        </div>
                                    </div>
                                    <div class="col-2 text-end" style="color: #979c9e">
                                        00:00
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="row justify-content-center">
                            <div class="col-10">
                                <div class="row" style="padding: 0px">
                                    <div class="col-3">
                                        <img src="/images/icon_user.png" class="rounded-circle" style="width: 100%" />
                                    </div>
                                    <div class="col">
                                        <h3 style="padding-top:8px;">
                                            xxxxxx
                                        </h3>
                                        <div style="padding: 5px; font-size: 12px; font-weight: bold">
                                            性別
                                            年齢
                                            住所
                                        </div>
                                    </div>
                                    <div class="col-2 text-end" style="color: #979c9e">
                                        00:00
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            count: 0,
            is_load_under: false,
            is_load: true,
            is_page: true,
            page_status: "4",
            page_type: "",
            page: 1,
            scrollY: 0,
            login_user: [],
            user_list: [],
            age_list: [],
            area_list: [],
            sex_list: [],
            last_line: "",
        };
    },
    mouted: function () {
        window.addEventListener("scroll", this.handleScroll)
    },
    methods: {
        async viewFootprint() {
            await axios.post("/api/user/footprint/viewed");
        },
        async fetchUsers() {
            await axios.get("/api/footprint/list")
                .then((response) => {
                    this.login_user = response.data.login_user
                    this.user_list = response.data.user_list
                    this.count = response.data.user_count
                    this.last_line = response.data.last_line

                    this.area_list = response.data.area_list
                    this.age_list = response.data.age_list
                    this.sex_list = response.data.sex_list

                    if (this.count <= 20) {
                        this.is_page = false
                    }

                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました");
                    }
                }).finally(() => {
                    this.is_load = false
                })
        },
        async fetchUsersMore() {

            this.is_load_under = true
            this.page++

            await axios.get("/api/footprint/list?last_line=" + this.last_line + "&page=" + this.page)
                .then((response) => {
                    this.user_list.push.apply(this.user_list, response.data.user_list)
                    
                    // last_lineを更新
                    if (response.data.last_line) {
                        this.last_line = response.data.last_line
                    }

                    if (response.data.user_list.length == 0) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました");
                    }
                }).finally(() => {
                    this.is_load_under = false
                })
        },
        async handleScroll() {
            let bottom = document.body.scrollHeight - document.body.clientHeight

            this.scrollY = window.scrollY
            let p = Math.abs(bottom - this.scrollY)
            if (p < 1 && this.is_page) {
                this.is_load_under = true
                this.page++

                await axios.get("/api/footprint/list?last_line=" + this.last_line + "&page=" + this.page)
                    .then((response) => {
                        this.user_list.push.apply(this.user_list, response.data.user_list)
                        
                        // last_lineを更新
                        if (response.data.last_line) {
                            this.last_line = response.data.last_line
                        }

                        if (response.data.user_list.length == 0) {
                            this.is_page = false
                        }
                    })
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("ユーザーの取得に失敗しました");
                        }
                    }).finally(() => {
                        this.is_load_under = false
                    })
            }
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            localStorage.setItem('prev_page', this.$route.path)
                            localStorage.setItem('prev_type', 1)

                            window.addEventListener("scroll", this.handleScroll)
                            this.viewFootprint()
                            this.fetchUsers()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました");
                    })
            }
            else {
                localStorage.setItem('prev_page', this.$route.path)
                localStorage.setItem('prev_type', 1)

                window.addEventListener("scroll", this.handleScroll)
                this.viewFootprint()
                this.fetchUsers()
            }
        }
        else {
            localStorage.setItem('prev_page', this.$route.path)
            localStorage.setItem('prev_type', 1)

            window.addEventListener("scroll", this.handleScroll)
            this.viewFootprint()
            this.fetchUsers()
        }
    },
    filters: {
        priceLocaleString(value) {
            return value.toLocaleString()
        },
    },
};
</script>

<style>
.dateline {
    background: #E3E5E5;
    color: #6C7072;
}

.planbox {
    position: fixed;
    z-index: 999;
    top: 120px;
    bottom: 0;
    left: -12px;
    right: -12px;
    background: rgba(255, 255, 255, 0.80);
    color: #6B4EFF;
}

.mosaic {
    -ms-filter: blur(6px);
    filter: blur(6px);
}
</style>
